/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_CopyInputs */

const en_copy_copy = /** @type {(inputs: Copy_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const ar_copy_copy = /** @type {(inputs: Copy_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسخ`)
};

const bn_copy_copy = /** @type {(inputs: Copy_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কপি`)
};

const de_copy_copy = /** @type {(inputs: Copy_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren`)
};

const es_copy_copy = /** @type {(inputs: Copy_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const fr_copy_copy = /** @type {(inputs: Copy_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copie`)
};

const pt_copy_copy = /** @type {(inputs: Copy_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const zh_copy_copy = /** @type {(inputs: Copy_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制`)
};

const tr_copy_copy = /** @type {(inputs: Copy_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopyala`)
};

const ru_copy_copy = /** @type {(inputs: Copy_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копировать`)
};

const pl_copy_copy = /** @type {(inputs: Copy_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopia`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Copy_CopyInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const copy_copy = /** @type {((inputs?: Copy_CopyInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_CopyInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_copy_copy(inputs)
	if (locale === "bn") return bn_copy_copy(inputs)
	if (locale === "de") return de_copy_copy(inputs)
	if (locale === "es") return es_copy_copy(inputs)
	if (locale === "fr") return fr_copy_copy(inputs)
	if (locale === "pt") return pt_copy_copy(inputs)
	if (locale === "zh") return zh_copy_copy(inputs)
	if (locale === "tr") return tr_copy_copy(inputs)
	if (locale === "ru") return ru_copy_copy(inputs)
	if (locale === "pl") return pl_copy_copy(inputs)
	return en_copy_copy(inputs)
});